import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMiViewPlanSelector from './MiViewAccountSelector.hook';
import {
  formControlStyle,
  selectStyle,
  inputLabelStyle,
  menuItemStyle,
  selectPaperStyle,
} from './MiViewAccountSelector.style';

import { AccountSelectorProps } from './MiViewAccountSelector.types';

const MiViewAccountSelector: React.FC<AccountSelectorProps> = ({
  minWidth,
  accounts,
  selectedAccount,
  setSelectedAccount,
}) => {
  const { t } = useTranslation();
  const { handleChange, filteredAccounts } = useMiViewPlanSelector(accounts, setSelectedAccount);

  return (
    <FormControl size="small" sx={ { ...formControlStyle, minWidth } }>
      <InputLabel sx={ inputLabelStyle }>
        { t('maya_miview_account_dropdown_label') }
      </InputLabel>
      <Select
        sx={ selectStyle }
        size="small"
        value={ selectedAccount?.mdmId ?? '' }
        onChange={ handleChange }
        label={ t('maya_miview_cep_dropdown_label') }
        MenuProps={
          {
            PaperProps: {
              sx: { ...selectPaperStyle },
            },
          }
        }
      >
        <MenuItem value="" sx={ menuItemStyle }>
          { t('maya_miview_dropdown_none_label') }
        </MenuItem>

        {
          filteredAccounts?.map((account, index) => (
            <MenuItem key={ index } value={ account?.mdmId || '' } sx={ menuItemStyle }>
              { `${account.lastName || '-'}, ${account.firstName || '-'}` }
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};

export default MiViewAccountSelector;

